import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = {
    key: "actions",
    class: "float-end"
};
const _hoisted_6 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_7 = {
    key: 1,
    class: "clearfix"
};
const _hoisted_8 = { class: "form-contents" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "clearfix" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12" };
const _hoisted_12 = { class: "x_panel" };
const _hoisted_13 = { class: "x_content" };
const _hoisted_14 = {
    class: "clearfix",
    key: "profile"
};
const _hoisted_15 = { class: "clearfix" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_17 = { class: "invalid-feedback" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_19 = { class: "invalid-feedback" };
const _hoisted_20 = { class: "clearfix" };
const _hoisted_21 = { class: "col-xs-12 col-sm-2 col-md-6 bottom10" };
const _hoisted_22 = { class: "invalid-feedback" };
const _hoisted_23 = { class: "col-xs-12 col-sm-2 col-md-3 bottom10" };
const _hoisted_24 = { class: "invalid-feedback" };
const _hoisted_25 = { class: "col-xs-12 col-sm-2 col-md-3 bottom10" };
const _hoisted_26 = { class: "invalid-feedback" };
const _hoisted_27 = { class: "clearfix" };
const _hoisted_28 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_29 = { class: "clearfix" };
const _hoisted_30 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_31 = { class: "checkbox-wrapper" };
const _hoisted_32 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_33 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_34 = { class: "checkbox-wrapper" };
const _hoisted_35 = {
    class: "clearfix",
    key: "password"
};
const _hoisted_36 = { class: "clearfix" };
const _hoisted_37 = { class: "col-xs-12 col-sm-12" };
const _hoisted_38 = { class: "clearfix" };
const _hoisted_39 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_40 = { class: "clearfix" };
const _hoisted_41 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_42 = { class: "invalid-feedback" };
const _hoisted_43 = { class: "clearfix" };
const _hoisted_44 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_45 = { class: "invalid-feedback" };
const _hoisted_46 = {
    key: 0,
    class: "x_panel"
};
const _hoisted_47 = { class: "x_title mb-0" };
const _hoisted_48 = { class: "x_content" };
const _hoisted_49 = { class: "card bg-white data-grid detached" };
const _hoisted_50 = { class: "table table-hover small bottom0 pw100" };
const _hoisted_51 = ["href"];
const _hoisted_52 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_PasswordLegendVue = _resolveComponent("PasswordLegendVue");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle), 1 /* TEXT */)
            ]),
            _cache[22] || (_cache[22] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    (!_ctx.changingPassword)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_b_button, {
                                type: "button",
                                variant: "primary",
                                onClick: _ctx.save
                            }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                        _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            _withDirectives(_createVNode(_component_b_button, {
                                type: "button",
                                variant: "warning",
                                onClick: _ctx.requestPasswordChange
                            }, {
                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                        _createElementVNode("i", { class: "fa fa-lock" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Change Password", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]), [
                                [_vShow, !_ctx.isThirdPartyAuth]
                            ]),
                            _cache[16] || (_cache[16] = _createTextVNode()),
                            _createVNode(_component_router_link, {
                                to: { name: _ctx.termsRouteName }
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "secondary"
                                    }, {
                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                _createElementVNode("i", { class: "fa fa-lock" }, null, -1 /* CACHED */),
                                                _createElementVNode("span", { class: "hidden-xs" }, " Terms and Conditions", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["to"]),
                            _cache[17] || (_cache[17] = _createTextVNode()),
                            _createVNode(_component_b_button, {
                                type: "button",
                                variant: "secondary",
                                onClick: _ctx.goBack
                            }, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[21] || (_cache[21] = _createTextVNode()),
                    (_ctx.changingPassword)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_b_button, {
                                type: "button",
                                variant: "primary",
                                onClick: _ctx.changePassword
                            }, {
                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                        _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Save Password", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]),
                            _cache[20] || (_cache[20] = _createTextVNode()),
                            _createVNode(_component_b_button, {
                                type: "button",
                                variant: "secondary",
                                onClick: _ctx.requestPasswordChange
                            }, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                        _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ]),
        _cache[76] || (_cache[76] = _createTextVNode()),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _cache[63] || (_cache[63] = _createElementVNode("div", { class: "x_title" }, [
                                _createElementVNode("h2", null, "Your Details"),
                                _createTextVNode(),
                                _createElementVNode("div", { class: "clearfix" })
                            ], -1 /* CACHED */)),
                            _cache[64] || (_cache[64] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_13, [
                                (!_ctx.changingPassword)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _cache[23] || (_cache[23] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tFirst Name *\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[24] || (_cache[24] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.firstNameVal, {
                                                    type: "text",
                                                    modelValue: _ctx.profile.firstName,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.profile.firstName) = $event)),
                                                    modelModifiers: { trim: true },
                                                    name: "firstName",
                                                    class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.firstName },
                                                    maxlength: "50"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[25] || (_cache[25] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_17, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* Please enter a first name\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.firstName]
                                                ])
                                            ]),
                                            _cache[29] || (_cache[29] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_18, [
                                                _cache[26] || (_cache[26] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tLast Name *\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[27] || (_cache[27] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.lastNameVal, {
                                                    type: "text",
                                                    modelValue: _ctx.profile.lastName,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.profile.lastName) = $event)),
                                                    modelModifiers: { trim: true },
                                                    name: "lastName",
                                                    class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.lastName },
                                                    maxlength: "50"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[28] || (_cache[28] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_19, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* Please enter a last name\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.lastName]
                                                ])
                                            ])
                                        ]),
                                        _cache[45] || (_cache[45] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_20, [
                                            _createElementVNode("div", _hoisted_21, [
                                                _cache[30] || (_cache[30] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tEmail\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[31] || (_cache[31] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.emailVal, {
                                                    type: "email",
                                                    modelValue: _ctx.profile.emailAddress,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.profile.emailAddress) = $event)),
                                                    modelModifiers: { trim: true },
                                                    name: "email",
                                                    class: { 'is-invalid': (_e = _ctx.errors) === null || _e === void 0 ? void 0 : _e.email },
                                                    maxlength: "255"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[32] || (_cache[32] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_22, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid email\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_f = _ctx.errors) === null || _f === void 0 ? void 0 : _f.email]
                                                ])
                                            ]),
                                            _cache[39] || (_cache[39] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_23, [
                                                _cache[33] || (_cache[33] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tWork Phone\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[34] || (_cache[34] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.workPhoneVal, {
                                                    type: "tel",
                                                    modelValue: _ctx.profile.workPhone,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.profile.workPhone) = $event)),
                                                    modelModifiers: { trim: true },
                                                    name: "workPhone",
                                                    class: { 'is-invalid': (_g = _ctx.errors) === null || _g === void 0 ? void 0 : _g.workPhone },
                                                    maxlength: "50"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[35] || (_cache[35] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_24, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid phone number\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_h = _ctx.errors) === null || _h === void 0 ? void 0 : _h.workPhone]
                                                ])
                                            ]),
                                            _cache[40] || (_cache[40] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_25, [
                                                _cache[36] || (_cache[36] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tMobile Phone\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[37] || (_cache[37] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.mobilePhoneVal, {
                                                    type: "tel",
                                                    modelValue: _ctx.profile.mobilePhone,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.profile.mobilePhone) = $event)),
                                                    modelModifiers: { trim: true },
                                                    name: "mobilePhone",
                                                    class: { 'is-invalid': (_j = _ctx.errors) === null || _j === void 0 ? void 0 : _j.mobilePhone },
                                                    maxlength: "50"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[38] || (_cache[38] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_26, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid phone number\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_k = _ctx.errors) === null || _k === void 0 ? void 0 : _k.mobilePhone]
                                                ])
                                            ])
                                        ]),
                                        _cache[46] || (_cache[46] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_27, [
                                            _createElementVNode("div", _hoisted_28, [
                                                _cache[41] || (_cache[41] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tPosition / Title\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[42] || (_cache[42] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    modelValue: _ctx.profile.position,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.profile.position) = $event)),
                                                    modelModifiers: { trim: true },
                                                    maxlength: "100"
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ])
                                        ]),
                                        _cache[47] || (_cache[47] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createVNode(_component_b_form_checkbox, {
                                                        id: "useImperialMeasurementSystem",
                                                        modelValue: _ctx.profile.useImperialMeasurementSystem,
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.profile.useImperialMeasurementSystem) = $event)),
                                                        size: "lg"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tPrefer Imperial measurement system to Metric\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["modelValue"])
                                                ])
                                            ])
                                        ]),
                                        _cache[48] || (_cache[48] = _createTextVNode()),
                                        (_ctx.canEnableDisableTwoFactorAuth)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                _createElementVNode("div", _hoisted_33, [
                                                    _createElementVNode("div", _hoisted_34, [
                                                        _createVNode(_component_b_form_checkbox, {
                                                            id: "twofactorAuthEnabled",
                                                            modelValue: _ctx.profile.twoFactorAuthEnabled,
                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.profile.twoFactorAuthEnabled) = $event)),
                                                            size: "lg"
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tEnable Two-Factor Authentication (2FA)\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                ]))]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["modelValue"])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _cache[62] || (_cache[62] = _createTextVNode()),
                                (_ctx.changingPassword)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                        _createElementVNode("div", _hoisted_36, [
                                            _createElementVNode("div", _hoisted_37, [
                                                _createVNode(_component_b_alert, {
                                                    show: "",
                                                    variant: "primary"
                                                }, {
                                                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tMinimum password length is 7 characters. Please use a mix of letters and numbers, as well as upper and lower-case characters.\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                })
                                            ])
                                        ]),
                                        _cache[59] || (_cache[59] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_38, [
                                            _createElementVNode("div", _hoisted_39, [
                                                _cache[50] || (_cache[50] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tCurrent Password *\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[51] || (_cache[51] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.currentPasswordVal, {
                                                    type: "password",
                                                    modelValue: _ctx.password.currentPassword,
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.password.currentPassword) = $event)),
                                                    name: "password",
                                                    class: { 'is-invalid': (_l = _ctx.errors) === null || _l === void 0 ? void 0 : _l.currentPassword }
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"])
                                            ])
                                        ]),
                                        _cache[60] || (_cache[60] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_40, [
                                            _createElementVNode("div", _hoisted_41, [
                                                _cache[52] || (_cache[52] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tNew Password *\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[53] || (_cache[53] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.newPasswordVal, {
                                                    type: "password",
                                                    modelValue: _ctx.password.newPassword,
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.password.newPassword) = $event)),
                                                    name: "newPassword",
                                                    class: { 'is-invalid': (_m = _ctx.errors) === null || _m === void 0 ? void 0 : _m.newPassword },
                                                    ref: "newPassword"
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[54] || (_cache[54] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_42, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* Please enter a valid password\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_o = _ctx.errors) === null || _o === void 0 ? void 0 : _o.newPassword]
                                                ]),
                                                _cache[55] || (_cache[55] = _createTextVNode()),
                                                _createVNode(_component_PasswordLegendVue)
                                            ])
                                        ]),
                                        _cache[61] || (_cache[61] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("div", _hoisted_44, [
                                                _cache[56] || (_cache[56] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tConfirm Password *\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[57] || (_cache[57] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.confirmPasswordVal, {
                                                    type: "password",
                                                    modelValue: _ctx.password.newPasswordConfirmation,
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.password.newPasswordConfirmation) = $event)),
                                                    name: "confirmationPassword",
                                                    class: { 'is-invalid': (_p = _ctx.errors) === null || _p === void 0 ? void 0 : _p.passwordConfirmation }
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                                _cache[58] || (_cache[58] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_45, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t* The confirmation password does not match with the new password\r\n\t\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_q = _ctx.errors) === null || _q === void 0 ? void 0 : _q.passwordConfirmation]
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]),
                        _cache[75] || (_cache[75] = _createTextVNode()),
                        (_ctx.isClient)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("h2", null, "Administrator" + _toDisplayString(_ctx.clientAdmins.length > 0 ? 's' : ''), 1 /* TEXT */),
                                    _cache[65] || (_cache[65] = _createTextVNode()),
                                    _cache[66] || (_cache[66] = _createElementVNode("div", { class: "clearfix" }, null, -1 /* CACHED */))
                                ]),
                                _cache[74] || (_cache[74] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("table", _hoisted_50, [
                                            _cache[71] || (_cache[71] = _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", null, [
                                                        _createElementVNode("span", null, "Administrator Name")
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("th", null, [
                                                        _createElementVNode("span", null, "Company Name")
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("th", { class: "hidden-sm" }, [
                                                        _createElementVNode("span", null, "Email")
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tMobile Phone\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                ])
                                            ], -1 /* CACHED */)),
                                            _cache[72] || (_cache[72] = _createTextVNode()),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientAdmins, (user) => {
                                                    return (_openBlock(), _createElementBlock("tr", null, [
                                                        _createElementVNode("td", null, _toDisplayString(user.displayName), 1 /* TEXT */),
                                                        _cache[67] || (_cache[67] = _createTextVNode()),
                                                        _createElementVNode("td", null, _toDisplayString(user.companyName), 1 /* TEXT */),
                                                        _cache[68] || (_cache[68] = _createTextVNode()),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("a", {
                                                                href: 'mailto:' + user.emailAddress
                                                            }, _toDisplayString(user.emailAddress), 9 /* TEXT, PROPS */, _hoisted_51)
                                                        ]),
                                                        _cache[69] || (_cache[69] = _createTextVNode()),
                                                        _createElementVNode("td", null, _toDisplayString(user.mobilePhone), 1 /* TEXT */)
                                                    ]));
                                                }), 256 /* UNKEYED_FRAGMENT */))
                                            ]),
                                            _cache[73] || (_cache[73] = _createTextVNode()),
                                            (_ctx.noData)
                                                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_52, [...(_cache[70] || (_cache[70] = [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("td", {
                                                                class: "text-center",
                                                                colspan: "3"
                                                            }, [
                                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tThere is no Client Administrators.\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                            ])
                                                        ], -1 /* CACHED */)
                                                    ]))]))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ])
        ])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
